export default __webpack_public_path__ + "static/one-click-publishing-e40e929a07c890a41dba06d9fd44b08d.mp4";